<template>
  <v-app>
    <div>

      <BreadcrumbComponent :items="items"></BreadcrumbComponent>

      <PreloaderComponent :enable="enable"></PreloaderComponent>

      <v-row justify="center">
        <v-dialog v-model="dialog" max-width="600px" @click:outside="close">

          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="text-h5">{{ form_title }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row style="margin-top:4px">
                  <v-col cols="6" sm="6" md="6">
                    <input label="Nom *" required v-model=device.name v-on:keyup="validateName()" placeholder="Nom *"
                      class="form-control"
                      :style="validate_name ? '' : 'border:2px solid #ff7370!important;box-shadow: none;'">
                    <small v-if="!validate_name" style="color:#ff7370;font-style:italic">
                      {{ validate_name_error_message }}
                    </small>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <select v-model=device.store_id class="form-control" label="Emplacement *" placeholder="Emplacement *" required>
                      <option value="" selected>-- Emplacement --</option>
                      <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">{{ store.name }}
                      </option>
                    </select>
                  </v-col>

                  <v-col cols="6" sm="6" md="6">
                    <input label="No de serie *" required v-model=device.serial_number v-on:keyup="validateSerialNumber()" placeholder="No de serie *"
                      class="form-control"
                      :style="validate_serial_number ? '' : 'border:2px solid #ff7370!important;box-shadow: none;'">
                    <small v-if="!validate_serial_number" style="color:#ff7370;font-style:italic">
                      {{ validate_serial_number_error_message}}
                    </small>
                  </v-col>

                  <v-col cols="6" sm="6" md="6">
                    <select v-model=device.status class="form-control" label="Statut *" placeholder="Statut *" disabled>
                      <option :value="true">Actif</option>
                      <option :value="false">Inactif</option>
                    </select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" class="close_modal_button" text @click="close">
                Fermer
              </v-btn>
              <v-btn color="blue" text class="confirm_modal_button" v-on:click="save" :loading="loading"
                :disabled="loading" @click="loader = 'loading'">
                Valider
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-container fluid class="settingscontainer" v-if=enable>
        <v-card elevation="2" class="text-right">

          <v-card>

            <v-card-title>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
                class="tablesearch">
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="headers" :items="rows" :items-per-page="10" class="elevation-1" :search="search">
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-left">{{ item.name }}</td>
                  <td class="text-left">{{ item.serial_number }}</td>
                  <td class="text-left">{{ item.manufacturer }}</td>
                  <td class="text-left">{{ item.type }}</td>

                  <td class="text-left" v-if='item.status == 1'><span class="badge badge-success">Actif</span></td>
                  <td class="text-left" v-if='item.status == 0'><span class="badge badge-danger">Inactif</span></td>

                  <td class="text-right action-cell">
                    <v-btn
                      icon
                      small
                      class="mr-2 action_button detail_button"
                      color="primary"
                      @click="openDeviceDetails(item)"
                    >
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>

                    <v-btn
                      icon
                      small
                      class="mr-2 action_button edit_button"
                      color="secondary"
                      @click="edit(item)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
          
        </v-card>
      </v-container>

      <!-- Modal Détails + Souscriptions -->
      <v-dialog v-model="detailsDialog" max-width="900px" scrollable>
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <div>
              <v-icon color="primary" class="mr-2">mdi-devices</v-icon>
              Détails de l'appareil
            </div>
            <v-btn icon @click="detailsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-overlay absolute :value="detailsLoading">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-overlay>

            <div v-if="deviceDetails && !detailsLoading">
              <v-row>
                <v-col cols="12" md="6">
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">Nom</v-list-item-title>
                        <v-list-item-subtitle>{{ deviceDetails.name }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">Numéro de série</v-list-item-title>
                        <v-list-item-subtitle>{{ deviceDetails.serial_number }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">Emplacement</v-list-item-title>
                        <v-list-item-subtitle>{{ deviceDetails.store?.name || '--' }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6">
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">Business</v-list-item-title>
                        <v-list-item-subtitle>{{ deviceDetails.business?.name || '--' }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">Prochaine échéance</v-list-item-title>
                        <v-list-item-subtitle>{{ nextRenewalDate }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">Statut</v-list-item-title>
                        <div class="device-status-chip" :class="deviceDetails.status ? 'status-active' : 'status-inactive'">
                          <v-icon small left>
                            {{ deviceDetails.status ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
                          </v-icon>
                          <span class="device-status-text">{{ deviceDetails.status ? 'Actif' : 'Inactif' }}</span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <!-- Souscriptions Actives -->
              <div class="mb-6">
                <h3 class="text-subtitle-1 font-weight-bold mb-2">
                  <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                  Souscriptions actives
                </h3>
                <v-alert v-if="!activeSubscriptions.length" type="info" outlined dense>
                  Aucune souscription active.
                </v-alert>

                <v-simple-table v-else dense>
                  <thead>
                    <tr>
                      <th>Plan</th>
                      <th>Statut souscription</th>
                      <th>Statut paiement</th>
                      <th>Transaction</th>
                      <th>Début</th>
                      <th>Fin</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="subscription in activeSubscriptions" :key="subscription.id">
                      <td>{{ subscription.plan?.name || subscription.plan_id }}</td>
                      <td>
                        <v-chip small :color="getSubscriptionStatusColor(subscription.status)" class="white--text">
                          {{ subscription.status }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip small :color="getPaymentStatusColor(subscription.payment_request?.status)" class="white--text">
                          {{ subscription.payment_request?.status || '--' }}
                        </v-chip>
                      </td>
                      <td>
                        <span v-if="getTransactionId(subscription)">{{ getTransactionId(subscription) }}</span>
                        <span v-else>--</span>
                      </td>
                      <td>{{ formatDate(subscription.starts_on) }}</td>
                      <td>{{ formatDate(subscription.ends_on) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>

              <!-- Souscriptions à venir -->
              <div class="mb-6">
                <h3 class="text-subtitle-1 font-weight-bold mb-2">
                  <v-icon small color="info" class="mr-1">mdi-calendar-clock</v-icon>
                  Souscriptions à venir
                </h3>
                <v-alert v-if="!upcomingSubscriptions.length" type="info" outlined dense>
                  Aucune souscription programmée.
                </v-alert>

                <v-simple-table v-else dense>
                  <thead>
                    <tr>
                      <th>Plan</th>
                      <th>Statut souscription</th>
                      <th>Statut paiement</th>
                      <th>Transaction</th>
                      <th>Début</th>
                      <th>Fin</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="subscription in upcomingSubscriptions" :key="subscription.id">
                      <td>{{ subscription.plan?.name || subscription.plan_id }}</td>
                      <td>
                        <v-chip small :color="getSubscriptionStatusColor(subscription.status)" class="white--text">
                          {{ subscription.status }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip small :color="getPaymentStatusColor(subscription.payment_request?.status)" class="white--text">
                          {{ subscription.payment_request?.status || '--' }}
                        </v-chip>
                      </td>
                      <td>
                        <span v-if="getTransactionId(subscription)">{{ getTransactionId(subscription) }}</span>
                        <span v-else>--</span>
                      </td>
                      <td>{{ formatDate(subscription.starts_on) }}</td>
                      <td>{{ formatDate(subscription.ends_on) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>

              <!-- Souscriptions échouées -->
              <div class="mb-6">
                <h3 class="text-subtitle-1 font-weight-bold mb-2">
                  <v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
                  Souscriptions échouées
                </h3>
                <v-alert v-if="!failedSubscriptions.length" type="info" outlined dense>
                  Aucune souscription échouée.
                </v-alert>

                <v-simple-table v-else dense>
                  <thead>
                    <tr>
                      <th>Plan</th>
                      <th>Statut souscription</th>
                      <th>Statut paiement</th>
                      <th>Transaction</th>
                      <th>Début</th>
                      <th>Fin</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="subscription in failedSubscriptions" :key="subscription.id">
                      <td>{{ subscription.plan?.name || subscription.plan_id }}</td>
                      <td>
                        <v-chip small :color="getSubscriptionStatusColor(subscription.status)" class="white--text">
                          {{ subscription.status }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip small :color="getPaymentStatusColor(subscription.payment_request?.status)" class="white--text">
                          {{ subscription.payment_request?.status || '--' }}
                        </v-chip>
                        <v-btn
                          v-if="(subscription.payment_request?.status || '').toUpperCase() === 'PENDING'"
                          icon
                          x-small
                          color="primary"
                          class="ml-1 verify-btn"
                          @click="verifySubscriptionPayment(subscription)"
                          title="Vérifier le paiement"
                        >
                          <v-icon x-small>mdi-refresh</v-icon>
                        </v-btn>
                      </td>
                      <td>
                        <span v-if="getTransactionId(subscription)">{{ getTransactionId(subscription) }}</span>
                        <span v-else>--</span>
                      </td>
                      <td>{{ formatDate(subscription.starts_on) }}</td>
                      <td>{{ formatDate(subscription.ends_on) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>

              <v-divider class="my-4"></v-divider>

              <div>
                <h3 class="text-subtitle-1 font-weight-bold mb-2">Renouvellement</h3>
                <v-row>

                  <v-col cols="12" md="6">
                    <v-select
                      dense
                      outlined
                      label="Plan"
                      :items="planOptions"
                      item-text="label"
                      item-value="id"
                      v-model="selectedPlanId"
                      :loading="plansLoading"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      dense
                      outlined
                      label="Méthode de paiement"
                      :items="paymentMethods"
                      item-text="label"
                      item-value="value"
                      v-model="selectedPaymentMethod"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row v-if="selectedPaymentMethod === 'moncash'" class="mt-2">

                  <v-col cols="12" md="6">
                    <label class="form-label font-weight-bold mb-1">Téléphone Moncash (8 chiffres)</label>
                    <input
                      class="form-control"
                      v-model="payerPhone"
                      maxlength="8"
                      type="tel"
                      placeholder="Ex: 29481919"
                    />
                  </v-col>
                </v-row>

                <v-alert
                  v-if="selectedPaymentMethod === 'natcash'"
                  type="info"
                  outlined
                  dense
                  class="mb-4 mt-2"
                >
                  Paiement Natcash (QR Code)
                </v-alert>
                <v-alert
                  v-if="selectedPaymentMethod === 'moncash_qr'"
                  type="info"
                  outlined
                  dense
                  class="mb-4 mt-2"
                >
                  Paiement Moncash (QR Code ou lien dans le navigateur)
                </v-alert>

                <v-alert
                  type="info"
                  outlined
                  dense
                  class="mb-4 mt-2"
                  v-if="selectedPlan"
                >
                  Montant: <strong>{{ selectedPlan.amount }} {{ selectedPlan.currency }}</strong> |
                  Durée: <strong>{{ selectedPlan.duration }} {{ selectedPlan.type }}</strong>
                </v-alert>

                <v-btn
                  v-if="showRenewalButton"
                  color="primary"
                  class="renewal-button"
                  style="width: 250px !important;"
                  :disabled="!selectedPlanId || !selectedPaymentMethod || (selectedPaymentMethod === 'moncash' && (!payerPhone || payerPhone.length !== 8))"
                  :loading="renewalLoading"
                  @click="startRenewal"
                >
                  <v-icon left small>mdi-credit-card</v-icon>
                  <span class="renewal-button__text">Procéder au paiement</span>
                </v-btn>

                <v-alert
                  v-if="renewalResult"
                  type="success"
                  outlined
                  class="mt-4"
                >
                  <div class="font-weight-bold mb-2">Paiement initié avec succès</div>
                  <div v-if="renewalResult.payment_request">
                    <p><strong>Commande:</strong> {{ renewalResult.payment_request.order_number }}</p>
                    <p><strong>Statut:</strong> {{ renewalResult.payment_request.status }} - {{ renewalResult.payment_request.message }}</p>
                    <p><strong>Montant:</strong> {{ renewalResult.payment_request.amount }} {{ renewalResult.payment_request.currency }}</p>
                    <p><strong>Expire le:</strong> {{ formatDate(renewalResult.payment_request.expired_at) }}</p>
                  </div>
                  <div v-if="renewalResult.subscription">
                    <p><strong>Plan:</strong> {{ renewalResult.subscription.plan_id }}</p>
                    <p><strong>Période:</strong> {{ formatDate(renewalResult.subscription.starts_on) }} → {{ formatDate(renewalResult.subscription.ends_on) }}</p>
                    <p><strong>Statut:</strong> {{ renewalResult.subscription.status }}</p>
                  </div>
                </v-alert>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Modal de suivi de paiement -->
      <v-dialog v-model="paymentDialog" max-width="520px" persistent>
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <div>Suivi du paiement</div>
            <v-btn icon @click="closePaymentDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-overlay absolute :value="paymentDialogLoading">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-overlay>

            <div v-if="paymentProcessor === 'moncash' && paymentRequestData?.short_url" class="text-center pa-4">
              <v-img
                :src="moncashLogo"
                max-width="140"
                contain
                class="mx-auto mb-3 payment-logo"
              ></v-img>
              <v-img
                v-if="paymentQrData"
                :src="paymentQrData"
                max-width="220"
                class="mx-auto mb-2 elevation-2"
              ></v-img>
              <p class="mb-3">Scannez ce QR Code avec MonCash ou ouvrez le lien ci-dessous pour valider votre paiement.</p>
              <v-btn
                color="primary"
                outlined
                class="mb-2"
                @click="openPaymentInBrowser"
              >
                <v-icon left small>mdi-open-in-new</v-icon>
                Ouvrir dans le navigateur
              </v-btn>
              <div class="text-center mt-4">
                <v-btn
                  v-if="!isPaymentConfirmed"
                  color="primary"
                  class="renewal-button"
                  style="width: 250px !important;"
                  :loading="verificationLoading"
                  @click="verifyPaymentStatus"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  <span class="renewal-button__text">Vérifier le paiement</span>
                </v-btn>
                <v-btn
                  v-else
                  color="success"
                  class="renewal-button"
                  style="width: 250px !important;"
                  @click="closeAllPaymentDialogs"
                >
                  <v-icon left small>mdi-check</v-icon>
                  <span class="renewal-button__text">Fermer</span>
                </v-btn>
              </div>
            </div>

            <div v-else-if="paymentProcessor === 'moncash'" class="text-center pa-4">
              <v-img
                :src="moncashLogo"
                max-width="180"
                contain
                class="mx-auto mb-4 payment-logo"
              ></v-img>
              <p>Votre paiement MonCash est en cours de validation. Veuillez vérifier votre téléphone et saisir votre code PIN pour confirmer.</p>
              <div class="text-center mt-4">
                <v-btn
                  v-if="!isPaymentConfirmed"
                  color="primary"
                  class="renewal-button"
                  style="width: 250px !important;"
                  :loading="verificationLoading"
                  @click="verifyPaymentStatus"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  <span class="renewal-button__text">Vérifier le paiement</span>
                </v-btn>
                <v-btn
                  v-else
                  color="success"
                  class="renewal-button"
                  style="width: 250px !important;"
                  @click="closeAllPaymentDialogs"
                >
                  <v-icon left small>mdi-check</v-icon>
                  <span class="renewal-button__text">Fermer</span>
                </v-btn>
              </div>
            </div>

            <div v-else-if="paymentProcessor === 'natcash'" class="text-center pa-4">
              <v-img
                v-if="paymentQrData"
                :src="paymentQrData"
                max-width="220"
                class="mx-auto mb-2 elevation-2"
              ></v-img>
              <p>Scannez ce QR Code avec l'application NatCash pour valider votre paiement.</p>
              <div class="text-danger font-weight-bold mt-2" v-if="paymentRequestData?.order_number">
                {{ paymentRequestData.order_number }}
              </div>
              <div class="text-center mt-4">
                <v-btn
                  v-if="!isPaymentConfirmed"
                  color="primary"
                  class="renewal-button"
                  style="width: 250px !important;"
                  :loading="verificationLoading"
                  @click="verifyPaymentStatus"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  <span class="renewal-button__text">Vérifier le paiement</span>
                </v-btn>
                <v-btn
                  v-else
                  color="success"
                  class="renewal-button"
                  style="width: 250px !important;"
                  @click="closeAllPaymentDialogs"
                >
                  <v-icon left small>mdi-check</v-icon>
                  <span class="renewal-button__text">Fermer</span>
                </v-btn>
              </div>
            </div>

            <v-alert
              v-if="verificationResult"
              :type="verificationResult.status === 'CONFIRMED' ? 'success' : 'info'"
              outlined
              class="mt-4"
            >
              <div><strong>Statut:</strong> {{ verificationResult.status }}</div>
              <div v-if="verificationResult.message">
                <strong>Message:</strong>
                <pre class="verification-message">{{ formatMessage(verificationResult.message) }}</pre>
              </div>
              <div v-if="verificationResult.transaction_id"><strong>Transaction:</strong> {{ verificationResult.transaction_id }}</div>
            </v-alert>
          </v-card-text>
        </v-card>
      </v-dialog>

    </div>
    <FlashMessage :position="'right bottom'"></FlashMessage>
  </v-app>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'
import PreloaderComponent from '../components/PreloaderComponent.vue'
import apiConfig from '../config/api'
import QRCode from 'qrcode'
import MoncashLogo from '../assets/moncash_large.png'

export default {
  name: 'DeviceView',
  methods: {
    load: async function () {
      this.business = JSON.parse(localStorage.business)
      this.authentication = JSON.parse(localStorage.authentication)
      this.business_id = JSON.parse(localStorage.business).id
      var self = this;
      this.$axios.get('/devices?include=business,store&business_id=' + this.business_id)
        .then(function (response) {
          self.rows = response.data
          self.enable = true
        })
    },
    validateName: function () {
      if (this.device.name == '') {
        this.validate_name = false
        this.validate_name_error_message = "Le nom ne peut pas être vide."
        return false
      } else {
        this.validate_name = true
        return true
      }
    },
    validateSerialNumber: function () {
      if (this.device.serial_number == '') {
        this.validate_serial_number = false
        this.validate_serial_number_error_message = "Le numéro de série ne peut pas être vide."
        return false
      } else if (this.device.serial_number.length < 10) {
        this.validate_serial_number = false
        this.validate_serial_number_error_message = "Le numéro de série doit contenir au moins 10 caractères."
        return false
      } else {
        this.validate_serial_number = true
        return true
      }
    },
    getStatusColor: function (status) {
      var color = "class_red"
      if (status) {
        color = "class_green"
      }
      return color
    },
    getStores: function () {
      var self = this;
      this.$axios.get('/stores?business_id=' + this.business_id)
        .then(function (response) {
          self.stores = response.data
        })
    },
    loadSubscriptionPlans: function () {
      var self = this
      this.plansLoading = true
      this.$axios.get('/subscription-plans')
        .then(function (response) {
          self.subscriptionPlans = response.data || []
        })
        .catch(function () {
          self.subscriptionPlans = []
        })
        .finally(function () {
          self.plansLoading = false
        })
    },
    refreshDeviceDetails: function (id) {
      this.detailsLoading = true
      this.$axios.get(`/devices/${id}?include=business,store,latest_subscriptions.plan,latest_subscriptions.payment_request`)
        .then(response => {
          this.deviceDetails = response.data
        })
        .catch(() => {
          this.deviceDetails = null
          this.flashMessage.error({
            title: 'Erreur',
            message: 'Impossible de charger les détails de l’appareil.'
          })
        })
        .finally(() => {
          this.detailsLoading = false
        })
    },
    openDeviceDetails: function (item) {
      this.detailsDialog = true
      this.deviceDetails = null
      this.selectedPlanId = null
      this.selectedPaymentMethod = this.paymentMethods[0]?.value || null
      this.payerPhone = ''
      this.renewalResult = null
      this.refreshDeviceDetails(item.id)
    },
    getSubscriptionStatusColor: function (status) {
      const map = {
        'ACTIVE': 'success',
        'EXPIRED': 'error',
        'PROCESSING': 'orange',
        'SCHEDULED': 'info'
      }
      return map[status] || 'grey'
    },
    getPaymentStatusColor: function (status) {
      const map = {
        'CONFIRMED': 'success',
        'PENDING': 'orange',
        'DENIED': 'error',
        'EXPIRED': 'grey'
      }
      return map[status] || 'grey'
    },
    getTransactionId: function (subscription) {
      const transactionId = (subscription?.payment_request?.transaction_id || '').toString().trim()
      return transactionId || ''
    },
    shouldShowPendingVerification: function (subscription, index) {
      if (!subscription?.payment_request) return false
      const status = (subscription.payment_request.status || '').toUpperCase().trim()
      if (status !== 'PENDING') return false
      const transactionId = this.getTransactionId(subscription)
      if (!transactionId) return false
      const subscriptions = this.deviceDetails?.latest_subscriptions || []
      return index === subscriptions.length - 1
    },
    verifySubscriptionPayment: function (subscription) {
      if (!subscription?.payment_request?.id) return
      this.paymentRequestData = subscription.payment_request
      this.paymentProcessor = (subscription.payment_request.processor_name || '').toLowerCase()
      this.paymentDialog = true
      this.verificationResult = null
      this.paymentQrData = ''
      if (this.paymentProcessor === 'natcash' || (this.paymentProcessor === 'moncash' && this.paymentRequestData?.short_url)) {
        this.generatePaymentQr(this.paymentRequestData)
      }
      this.verificationLoading = true
      const requestId = subscription.payment_request.id
      this.$axios.get(`/payment-requests/${requestId}`)
        .then(response => {
          const result = response.data || {}
          this.verificationResult = result
          if (result.status === 'CONFIRMED') {
            this.flashMessage.success({
              title: 'Paiement confirmé',
              message: `Transaction ${result.transaction_id || ''}`
            })
          } else {
            this.flashMessage.info({
              title: 'Information',
              message: result.message || 'Statut mis à jour'
            })
          }
          if (result.partner_response) {
            this.flashMessage.warning({
              title: 'Réponse du fournisseur',
              message: result.partner_response
            })
          }
          if (this.deviceDetails?.id) {
            this.refreshDeviceDetails(this.deviceDetails.id)
          }
        })
        .catch(() => {
          this.flashMessage.error({
            title: 'Erreur',
            message: 'Impossible de vérifier le paiement.'
          })
        })
        .finally(() => {
          this.verificationLoading = false
        })
    },
    formatDate: function (date) {
      if (!date) return '--'
      return new Date(date).toLocaleDateString('fr-FR')
    },
    formatMessage: function (message) {
      if (!message) return ''
      return message.replace(/\\n/g, '\n')
    },
    generatePaymentQr: async function (paymentRequest) {
      if (!paymentRequest) {
        this.paymentQrData = ''
        return
      }
      try {
        let qrData
        if (paymentRequest.short_url) {
          qrData = paymentRequest.short_url
        } else if (paymentRequest.order_number) {
          const baseUrl = apiConfig.apiUrl.endsWith('/')
            ? apiConfig.apiUrl
            : `${apiConfig.apiUrl}/`
          const url = `${baseUrl}pay/${paymentRequest.order_number}`
          qrData = paymentRequest.processor_name?.toLowerCase() === 'natcash'
            ? JSON.stringify({
                type: 2,
                code: 'keslakay',
                partnerCode: 'keslakay',
                consumerQrCode: url,
                consumerType: 'url'
              })
            : url
        } else {
          this.paymentQrData = ''
          return
        }
        this.paymentQrData = await QRCode.toDataURL(qrData, { width: 220 })
      } catch (error) {
        console.error('Erreur QR code:', error)
        this.paymentQrData = ''
      }
    },
    openPaymentInBrowser: function () {
      const url = this.paymentRequestData?.short_url
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer')
      }
    },
    closePaymentDialog: function () {
      this.paymentDialog = false
      this.paymentQrData = ''
      this.verificationResult = null
    },
    closeAllPaymentDialogs: function () {
      this.closePaymentDialog()
      this.detailsDialog = false
    },
    verifyPaymentStatus: function () {
      const paymentRequestId = this.paymentRequestData?.id || this.renewalResult?.subscription?.payment_request_id
      if (!paymentRequestId) {
        this.flashMessage.info({
          title: 'Information',
          message: 'Aucune requête de paiement à vérifier.'
        })
        return
      }
      this.verificationLoading = true
      this.$axios.get(`/payment-requests/${paymentRequestId}`)
        .then(response => {
          this.verificationResult = response.data || {}
          if (this.verificationResult.status === 'CONFIRMED') {
            this.flashMessage.success({
              title: 'Succès',
              message: 'Paiement confirmé !'
            })
          }
          if (this.verificationResult.partner_response) {
            this.flashMessage.warning({
              title: 'Réponse du fournisseur',
              message: this.verificationResult.partner_response
            })
          }
        })
        .catch(() => {
          this.flashMessage.error({
            title: 'Erreur',
            message: 'Impossible de vérifier le paiement.'
          })
        })
        .finally(() => {
          this.verificationLoading = false
        })
    },
    startRenewal: function () {
      if (!this.selectedPlanId || !this.selectedPaymentMethod) {
        this.flashMessage.info({
          title: 'Information',
          message: 'Veuillez sélectionner un plan et un moyen de paiement.'
        })
        return
      }
      if (this.selectedPaymentMethod === 'moncash') {
        if (!this.payerPhone || this.payerPhone.length !== 8) {
          this.flashMessage.info({
            title: 'Information',
            message: 'Numéro Moncash invalide (8 chiffres).'
          })
          return
        }
      }
      const plan = this.subscriptionPlans.find(p => p.id === this.selectedPlanId)
      const isMoncashUssd = this.selectedPaymentMethod === 'moncash'
      const processorName = isMoncashUssd || this.selectedPaymentMethod === 'moncash_qr' ? 'MONCASH' : this.selectedPaymentMethod.toUpperCase()
      const payload = {
        plan_id: this.selectedPlanId,
        processor_name: processorName,
        ussd: isMoncashUssd,
        serial_number: this.deviceDetails?.serial_number,
        business_id: this.deviceDetails?.business_id || this.business_id,
        payer: isMoncashUssd ? this.payerPhone : (this.deviceDetails?.business?.phone || '')
      }
      this.renewalLoading = true
      this.$axios.post('/subscriptions/pay', payload)
        .then((response) => {
          const message = response.data?.message || `Renouvellement via ${payload.processor_name} pour ${plan?.name || 'plan'} soumis.`
          this.flashMessage.success({
            title: 'Succès',
            message
          })
          this.renewalResult = response.data?.result || null
          this.paymentRequestData = this.renewalResult?.payment_request || null
          this.paymentProcessor = payload.processor_name.toLowerCase()
          this.paymentDialog = true
          this.verificationResult = null
          if (this.paymentProcessor === 'natcash' || (this.paymentProcessor === 'moncash' && this.paymentRequestData?.short_url)) {
            this.generatePaymentQr(this.paymentRequestData)
          } else {
            this.paymentQrData = ''
          }
        })
        .catch((error) => {
          const message = error.response?.data?.message || 'Erreur lors du renouvellement, veuillez réessayer.'
          this.flashMessage.error({
            title: 'Erreur',
            message
          })
          this.renewalResult = null
          this.paymentDialog = false
        })
        .finally(() => {
          this.renewalLoading = false
        })
    },
    save: function () {
      var self = this

      if (this.validateName() && this.validateSerialNumber() && this.device.store_id != '') {
        this.loading = true
        var url = ''
        if (this.index > -1) {
          url = '/devices/' + self.device.id
          this.$axios.put(url + "?include=business,store&data=" + encodeURIComponent(JSON.stringify(self.device)))
            .then(response => {
              Object.assign(self.rows[self.index], response.data)
              self.dialog = false
              self.loading = false
              self.reset()
            })
        } else {
          url = '/devices'
          this.device.business_id = this.business_id
          this.$axios.post(url + "?include=business,store&data=" + encodeURIComponent(JSON.stringify(self.device)))
            .then(response => {
              if (response.status < 200 || response.status > 299) {
                self.loading = false
                alert("Une erreur s'est produite. Veuillez réessayer plus tard ou contactez l'administrateur.")
                return
              }
              self.rows.push(response.data);
              self.dialog = false
              self.loading = false
              self.reset()
            }).catch(function () {
              self.loading = false
              alert("Une erreur s'est produite. Veuillez réessayer plus tard ou contactez l'administrateur.")
            })
        }
      } else {
        alert("Vérifiez les données du formulaire puis réessayez.")
      }
    },
    edit: function (item) {
      this.index = this.rows.indexOf(item)
      this.device = Object.assign({}, item)
      this.form_title = "Modifier l'Appareil : " + this.device.name
      this.dialog = true
    },
    close: function () {
      this.dialog = false
      this.reset()
      this.loading = false
    },
    reset: function () {
      this.device = {
        name: '',
        manufacturer: '',
        model: '',
        serial_number: '',
        store_id: "",
        amount: 0,
        status: true,
        next_renewal_date: (new Date(Date.now())).toISOString().substr(0, 10),
      }
      this.validate_name = true
      this.validate_serial_number = true
      this.index = -1
      this.form_title = 'Nouvel Appareil'
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.reset()
      })
    }
  },
  mounted() {
    this.load()
    this.getStores()
    this.loadSubscriptionPlans()
  },

  data: () => ({
    menu: false,
    modal: false,
    authentication: [],
    search: '',
    index: -1,
    onLoad: false,
    validate_name: true,
    validate_serial_number: true,
    validate_name_error_message: 'Le nom ne peut pas être vide.',
    validate_serial_number_error_message: 'Le numéro de série ne peut pas être vide.',
    loading: false,
    business_id: 0,
    form_title: "Nouvel Appareil",
    items: [
      {
        text: 'APPAREILS',
        disabled: false,
        href: '/point-of-sales',
      }
    ],
    fluid: true,
    enable: false,
    business: [],
    headers: [
      {
        text: 'NOM',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'SN', value: 'serial_number' },
      { text: 'FOURNISSEUR', value: 'manufacturer' },
      { text: 'TYPE', value: 'type' },
      { text: 'STATUT', value: 'status' },
      { text: 'ACTIONS', value: 'actions' },
    ],
    rows: [],
    detailsDialog: false,
    detailsLoading: false,
    deviceDetails: null,
    subscriptionPlans: [],
    plansLoading: false,
    selectedPlanId: null,
    selectedPaymentMethod: null,
    payerPhone: '',
    renewalLoading: false,
    renewalResult: null,
    paymentDialog: false,
    paymentProcessor: '',
    paymentRequestData: null,
    paymentQrData: '',
    paymentDialogLoading: false,
    verificationLoading: false,
    verificationResult: null,
    moncashLogo: MoncashLogo,
    paymentMethods: [
      { label: 'Natcash', value: 'natcash' },
      { label: 'Moncash (téléphone)', value: 'moncash' },
      { label: 'Moncash (QR / navigateur)', value: 'moncash_qr' },
    ],
    businesses: [],
    stores: [],
    dialog: '',
    dialogDelete: false,
    device: {
      name: '',
      manufacturer: '',
      model: '',
      serial_number: '',
      amount: 0,
      status: true,
      store_id: "",
      next_renewal_date: (new Date(Date.now())).toISOString().substr(0, 10),
    }
  }),
  components: { BreadcrumbComponent, PreloaderComponent },
  computed: {
    planOptions () {
      return (this.subscriptionPlans || []).map(plan => ({
        id: plan.id,
        label: `${plan.name} • ${plan.amount} ${plan.currency} · ${plan.duration} ${plan.type}`,
        amount: plan.amount,
        currency: plan.currency,
      }))
    },
    selectedPlan () {
      return (this.subscriptionPlans || []).find(plan => plan.id === this.selectedPlanId) || null
    },
    isPaymentConfirmed () {
      return (this.verificationResult?.status || '').toUpperCase() === 'CONFIRMED'
    },
    nextRenewalDate () {
      const activeSubs = this.activeSubscriptions
      if (!activeSubs.length) {
        return '--'
      }
      const sorted = [...activeSubs].sort((a, b) => new Date(b.ends_on || 0) - new Date(a.ends_on || 0))
      const date = sorted[0]?.ends_on
      return date ? this.formatDate(date) : '--'
    },
    latestSubscription () {
      const subs = this.deviceDetails?.latest_subscriptions || []
      if (!subs.length) return null
      return subs[0]
    },
    showRenewalButton () {
      const subs = this.deviceDetails?.latest_subscriptions || []
      if (!subs.length) return true
      const isPaid = (s) => (s?.payment_request?.status || '').toUpperCase() === 'CONFIRMED'
      const hasActivePaid = subs.some(s => (s?.status || '').toUpperCase() === 'ACTIVE' && isPaid(s))
      const hasScheduledPaid = subs.some(s => (s?.status || '').toUpperCase() === 'SCHEDULED' && isPaid(s))
      if (hasActivePaid && hasScheduledPaid) {
        return false
      }
      return true
    },
    activeSubscriptions () {
      const subs = this.deviceDetails?.latest_subscriptions || []
      return subs.filter(s => (s.status || '').toUpperCase() === 'ACTIVE')
    },
    upcomingSubscriptions () {
      const subs = this.deviceDetails?.latest_subscriptions || []
      return subs.filter(s => {
        const subStatus = (s.status || '').toUpperCase()
        const paymentStatus = (s.payment_request?.status || '').toUpperCase()
        return subStatus === 'SCHEDULED' && paymentStatus === 'CONFIRMED'
      })
    },
    failedSubscriptions () {
      const subs = this.deviceDetails?.latest_subscriptions || []
      return subs.filter(s => {
        const paymentStatus = (s.payment_request?.status || '').toUpperCase()
        return paymentStatus === 'DENIED' || paymentStatus === 'PENDING'
      })
    }
  }
}
</script>

<style type="text/css">
.text-right {
  text-align: right;
}

.theme--dark.v-btn.v-btn--has-bg {
  background-color: #003F74 !important;
}

.v-application--wrap .theme--dark.v-btn.v-btn--has-bg {
  background-color: #F68D3A !important;
}

.settingscontainer {
  margin-top: 25px !important;
}

.v-application a {
  color: black !important;
}

.tablesearch .v-input__control {
  border: 1px solid #ddd;
  padding: 5px 10px;
}

th.text-start,
td.text-start {
  text-align: center !important;
}

th.text-start:first-child,
td.text-start:first-child {
  text-align: left !important;
}

th.text-start:last-child,
td.text-start:last-child {
  text-align: right !important;
}

.class_green {
  background: #4caf50 !important;
  color: white !important;
}

.class_red,
.confirm_delete_button {
  background: #ff5252 !important;
  color: white !important;
}

.uppercase {
  text-transform: uppercase;
}

.text-center {
  text-align: center;
}

.tablesearch .v-input__slot:before {
  display: none;
}

.tablesearch .v-input__control {
  border: 1px solid #ddd;
  padding: 5px 10px;
}

.action_button {
  background: #1976d2 !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  color: white !important;
}

.edit_button {
  background: #757575 !important;
}

.detail_button {
  background: #1976D2 !important;
}

.action_button .v-icon {
  color: white !important;
}

.renewal-button {
  min-width: 250px !important;
  width: 250px !important;
  height: 44px !important;
  padding: 0 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #194173 !important;
  color: #ffffff !important;
}

/* S'assurer que le bouton renewal-button garde la couleur principale même quand actif */
.renewal-button.v-btn--active,
.renewal-button:active,
.renewal-button.active {
  background-color: #194173 !important;
  color: #ffffff !important;
}

.renewal-button__text {
  white-space: nowrap;
}

.payment-logo {
  border-radius: 8px;
  background: white;
  padding: 8px;
}

.text-danger {
  color: #e74c3c;
}

.device-status-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.device-status-chip .v-icon {
  margin-right: 6px;
}

.status-active {
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  color: white;
}

.status-inactive {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: white;
}

.verification-message {
  margin: 4px 0 0;
  white-space: pre-wrap;
  font-family: inherit;
}

.action-cell .v-btn {
  margin-right: 8px !important;
}

.verify-btn {
  width: 24px !important;
  height: 24px !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
}

.renew_button {
  font-size: 16px;
  padding: 5px;
  background: orange !important;
  color: white !important;
  border-radius: 4px;
}

.delete_button {
  background: #ff5252 !important;
  color: white !important;
  border-radius: 4px;
  font-size: 16px;
  padding: 5px;
}

.v-application .justify-center {
  justify-content: right !important;
}

.v-application .v-btn {
  width: 70px !important;
  margin-right: 22px;
  margin-top: 18px;
}

.v-application .v-dialog .v-btn {
  width: 70px !important;
  margin-right: 22px;
  margin-top: 0px !important;
}

.v-dialog .v-card__title {
  background: #f3f3f3;
  border-bottom: 1px solid #ddd;
}

.v-btn.close_modal_button {
  background-color: #1976d2 !important;
  color: white !important;
}

.v-btn.confirm_modal_button {
  background-color: #4caf50 !important;
  color: white !important;
}

.v-dialog .v-card__actions {
  padding-bottom: 15px !important;
  padding-top: 20px !important;
  background: #f3f3f3;
  border-top: 1px solid #ddd;
}

.new_button {
  margin-top: -7px !important;
}

.color-red {
  color: red !important;
}

.has_errors {
  padding-top: 0px;
  margin-top: 0px;
}

.v-card__actions .v-progress-circular {
  margin-top: 1px !important;
}

.v-progress-circular {
  margin-top: 40px !important;
}

.v-card__actions .v-progress-circular circle {
  color: white !important;
}

.background_red {
  background: #f2dede;
}

.v-progress-circular{
  margin-top: -4px !important;
}

.background_yellow {
  background: #fcf8e3;
}
</style>